<template>
	<div class="right_body">
		<search-box :fromData="fromData" @subSearch="subSearch"></search-box>
    <list-btn :listArr="listArr"></list-btn>
    <tab-list
    :tabList="listArr"
    :total="total"
    :pages="pages"
    :fromData="fromData"
    :columns="tabColumns"
    tabName="business-purchasein-list"
    @currentChange="currentChange"
    @changePages="changePages"
    @selectSdata="selectSdata"
    @dbClick="dbClick">
    </tab-list>

    <!-- 详情 -->
    <el-dialog title="采购入库详情"
    :visible.sync="dialogFormVisible"
    customClass="dialog_detail_style"
    v-dialogDrag @closed="closedDialog" >
      <v-detail :sdata="detailSdata" class="contnet_box" style="overflow-y:hidden;"></v-detail>
    </el-dialog>

	</div>
</template>

<script>
	import {purchaseinstock} from 'api/business.js';
	import listBtn from 'components/btn/listBtn.vue'
	import tabList  from 'components/table/list.vue';
	import searchBox from './components/list/search.vue'
  import vDetail from './detail.vue';

	export default{
		components:{
			listBtn,
			tabList,
			searchBox,
      vDetail
		},
		data() {
			return {
        dialogFormVisible:false,
        detailSdata:{},
				sdata:{},
				listArr:[],
				tabColumns:[
				  {field: 'materailVoucherNo', title: '入库单号',need:true,width:100,"sortable":true},
				  {field: 'voucherDate', title: '凭证日期',width:100},
				  {field: 'postingDate', title: '过账日期',width:100},
				  {field: 'materialCode', title: '物料编码',width:100},
				  {field: 'materialDesc', title: '物料描述'},
				  {field: 'factoryCode', title: '工厂',
				  formatter: function (rowData) {
				    let code = rowData.factoryCode ? rowData.factoryCode : '';
				    let desc = rowData.factoryDesc ? rowData.factoryDesc : '';
				    return code +'-' +desc;
				  }},
				  {field: 'inventoryCode', title: '库存地点',
				  formatter: function (rowData) {
				    let code = rowData.inventoryCode ? rowData.inventoryCode : '';
				    let desc = rowData.inventoryDesc ? rowData.inventoryDesc : '';
				    return code +'-' +desc;
				  }},
          /* {field: 'voucherHeaderTxt', title: '备注'}, */
          {field: 'projectTxt', title: '备注'},
				],//表头字段
				total:0,//总条数
				pages:0,//总页数
				fromData:{
					page:1,//当前页
					pageSize:20,//每页显示的数量,
					searchCriteria:{//查询的附加条件
					}
				}
			}
		},
		created(){
			this.getList();
		},
		methods:{
      //双击
      dbClick(data){
        this.sdata = data;
        this.goDetail();
      },
      //选中数据
      selectSdata(data){
        this.sdata = data;
      },
			//获取列表
			async getList(){
				let res = await this.$post(purchaseinstock.list,this.fromData);
        if(res.status && res.data){
          this.pages = res.data.pages;
          this.listArr = res.data.list;
          this.total = res.data.total;
        }else{
          this.pages = 0;
          this.listArr = [];
          this.total = 0;
        }
			},
			//当前页码改变
			currentChange(currentPage){
				this.fromData.page = currentPage;
				this.getList();
			},
      //页码条数改变
      changePages(pages){
        this.fromData.page = 1;
        this.fromData.pageSize = pages;
        this.getList();
      },
			//搜索
			subSearch(){
				this.fromData.page = 1;
				this.getList();
			},
			handleSelectChange(item,key){
				if(item.isChecked){
					item.isChecked = false;
					this.sdata = {};
				}else{
					this.sdata = item;
					this.sdata.index = key;
					item.isChecked = true;
					this.listArr.forEach((items)=>{
						if(items.materialVoucherId != item.materialVoucherId){
							items.isChecked = false;
						}
					});
				}
			},
			//选择的改变
			changeSelect(val,item,key){
				this.handleSelectChange(item,key);
			},
      //详情
      async goDetail(){
        if(!this.sdata.materialVoucherId){
          this.$message.error('请选择要查看的记录');
          return;
        }

        let res = await this.$get(purchaseinstock.find,{"purchaseInStockId":this.sdata.materialVoucherId});
        this.dialogFormVisible = true;
        //console.log(res.data,'====== 返回的数据 ===');return;
        if(res.status) this.detailSdata = res.data;
      },
      //关闭弹出层
      closedDialog(){
        this.dialogFormVisible = false;
      },
			//删除
			del(){
				let vm = this;
				if(!this.sdata.materialVoucherId){
					this.$message.error('请选择需要删除的');
					return;
				}
				this.$confirm('确定删除这条记录, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
				.then(async () => {
					vm.$loading.show('处理中...');
					let res = await vm.$get(matterApi.del,{materialCode:this.sdata.materialCode});
					const {data,msg,status,code} = res;
					if(status){
						this.sdata.isDel = true;
						this.listArr[this.sdata.index] = this.sdata;
						vm.$message.success(msg);
					}else{
						vm.$message.error(msg);
					}
				})
				.catch(() => {
					/* this.$message({
						type: 'info',
						message: '已取消删除'
					});  */
				});
			},
			//恢复删除
			restore(){
				let vm = this;
				if(!this.sdata.materialVoucherId){
					this.$message.error('请选择需要恢复的物料');
					return;
				}
				this.$confirm('恢复此条记录, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
				.then(async () => {
					vm.$loading.show('处理中...');
					let res = await vm.$get(matterApi.restore,{materialCode:this.sdata.materialCode});
					const {data,msg,status,code} = res;
					if(status){
						this.sdata.isDel = false;
						this.listArr[this.sdata.index] = this.sdata;
						vm.$message.success(msg);
					}else{
						vm.$message.error(msg);
					}
				});
			}

		}
	}
</script>

<style lang="stylus" scoped>

</style>
